import { render, staticRenderFns } from "./FormFieldsModal.vue?vue&type=template&id=58a757b9"
import script from "./FormFieldsModal.vue?vue&type=script&lang=js"
export * from "./FormFieldsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports